import { useRef, useState } from "react";
import imageCompression from 'browser-image-compression';

import Webcam from "react-webcam";

import { base64URLToFile } from "../../../../utils/base64ToFile";

import styles from "./styles.module.scss";

 const options = {
    maxSizeMB: 2,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  }

const CameraModal = ({ onClose, onCapture , setFiles , files }) => {
  const webcamRef = useRef(null);
  const [capturedImage, setCapturedImage] = useState(null);

  const handleCapture = async () => {
    const imageSrc = webcamRef.current?.getScreenshot();

    if(files.length >= 3){
      alert("Maximum 3 files allowed");
      return;
    }
    if (imageSrc) {
      setCapturedImage(imageSrc);
    //   const id = Date.now();
    //   const fileObject = base64URLToFile(imageSrc,`image${id}.jpeg`);

    //   const compressedBlob  = await imageCompression(fileObject, options);

    //   const compressedFile = new File(
    //   [compressedBlob],
    //   `image${id}.jpeg`,
    //   {
    //     type: compressedBlob.type,
    //     lastModified: Date.now(),
    //   }
    // );

    //   setFiles([...files , compressedFile])
    }
  };

  const handleRetake = () => {
    setCapturedImage(null);
  };

  const handleConfirm = async () => {
    if (capturedImage ) {
       const id = Date.now();
      const fileObject = base64URLToFile(capturedImage,`image${id}.jpeg`);

      const compressedBlob  = await imageCompression(fileObject, options);

      const compressedFile = new File(
      [compressedBlob],
      `image${id}.jpeg`,
      {
        type: compressedBlob.type,
        lastModified: Date.now(),
      }
    );

      setFiles([...files , compressedFile])
      // onCapture(capturedImage);
    }
    onClose();
  };

  console.log(files , "files in camera modal")

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h2 className={styles.title}>Capture Photo</h2>

        <div className={styles.cameraContainer}>
          {!capturedImage ? (
            <Webcam
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              className={styles.webcam}
              videoConstraints={{
                facingMode: "environment",
                width: 1280,
                height: 720,

              }}
            />
          ) : (
            <img src={capturedImage} alt="Captured" className={styles.preview} />
          )}
        </div>

        <div className={styles.actions}>
          {!capturedImage ? (
            <>
              <button className={styles.captureBtn} onClick={handleCapture}>
                Capture
              </button>
              <button className={styles.cancelBtn} onClick={onClose}>
                Cancel
              </button>
            </>
          ) : (
            <>
              <button className={styles.retakeBtn} onClick={handleRetake}>
                Retake
              </button>
              <button className={styles.submitBtn} onClick={handleConfirm}>
                Use Photo
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CameraModal;